// extracted by mini-css-extract-plugin
export var adjacentSlide = "_r7-9";
export var arrowButtonContainer = "_r7-5";
export var arrowButtonIcon = "_r7-6";
export var carouselArrowButton = "_r7-2";
export var carouselElementContainer = "_r7-1";
export var currentSlide = "_r7-8";
export var left = "_r7-3";
export var otherSlide = "_r7-a";
export var productCarouselContainer = "_r7-0";
export var right = "_r7-4";
export var sliderOverflow = "_r7-7";